/* eslint-disable no-param-reassign */
import arrayToCost from '../helpers/arrayToCost';

const emptyFaces = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

const initialState = {
  walletContent: [...emptyFaces],
  cost: 0,
  paymentContent: [...emptyFaces],
  returnContent: [...emptyFaces],
};

export default {
  state: { ...initialState },
  selectors: (slice) => ({
    walletTotal: () => slice((state) => arrayToCost(state.walletContent)),
    paymentTotal: () => slice((state) => arrayToCost(state.paymentContent)),
    returnTotal: () => slice((state) => arrayToCost(state.returnContent)),
  }),
  reducers: {
    clear: () => ({ ...initialState }),
    walletAdd: (state, face) => {
      state.walletContent[face] += 1;
    },
    walletSub: (state, face) => {
      state.walletContent[face] = Math.max(state.walletContent[face] - 1, 0);
    },
    walletClear: (state) => {
      state.walletContent = [...emptyFaces];
    },
    costSet: (state, cost) => {
      state.cost = cost;
    },
    paymentSet: (state, payload) => {
      state.paymentContent = [...payload];
    },
    paymentClear: (state) => {
      state.paymentContent = [...emptyFaces];
    },
    returnAdd: (state, face) => {
      state.returnContent[face] += 1;
    },
    returnSub: (state, face) => {
      state.returnContent[face] = Math.max(state.returnContent[face] - 1, 0);
    },
    returnClear: (state) => {
      state.returnContent = [...emptyFaces];
    },
    applyTransaction: (state) => {
      for (let i = 0; i < 15; i += 1) {
        state.walletContent[i] =
          state.walletContent[i] -
          state.paymentContent[i] +
          state.returnContent[i];
      }
      state.cost = 0;
      state.paymentContent = [...emptyFaces];
      state.returnContent = [...emptyFaces];
    },
  },
};
